//frontend/src/slices/productSlice.js
import { createSlice } from "@reduxjs/toolkit";

const productsSlice = createSlice({
    name: 'products',
    initialState: {
        loading: false,
        products: [],
        productsCount: 0,
        resPerPage: 8,
        filteredProductsCount: 0,
        error: null
    },
    reducers: {
        productsRequest(state) {
            state.loading = true;
            state.error = null;
        },
        productsSuccess(state, action) {
            state.loading = false;
            state.products = action.payload.products;
            state.productsCount = action.payload.count;
            state.resPerPage = action.payload.resPerPage;
            state.filteredProductsCount = action.payload.filteredProductsCount;
            state.error = null;
        },
        productsFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearProducts(state) {
            state.products = [];
            state.productsCount = 0;
            state.filteredProductsCount = 0;
            state.error = null;
        }
    }
});

export const {
    productsRequest,
    productsSuccess,
    productsFail,
    clearProducts
} = productsSlice.actions;

export default productsSlice.reducer;
